import { useState, useEffect } from 'react';
import config from 'config-base';
import useExternalRedirect from '@/hooks/useExternalRedirect';
import AuthApiService from '@/api/auth';
import { apiClient } from '@/services/base';
import { User } from '@/types/User';
import useOnWindowFocus from '../useWindowFocus';
import useFirstRender from '../useFirstRender';

const authService = new AuthApiService(apiClient);

export default function useAuth(userData: User | null) {
  const { redirect } = useExternalRedirect();
  const [user, setUser] = useState<User | null>(userData);
  const { isWindowFocused } = useOnWindowFocus();
  const firstRender = useFirstRender();

  const fetchUser = async () => {
    try {
      const res = await authService.getUser();
      setUser(res.data);
    } catch (error) {
      console.error('Failed to fetch user:', error);
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
      setUser(null);
      redirect(config.mainPyramydairUrl);
    } catch (error) {
      console.error('Failed to logout:', error);
    }
  };

  useEffect(() => {
    if (isWindowFocused && !firstRender) {
      fetchUser();
    }
  }, [isWindowFocused]);

  return { user, logout };
}
